import React from "react";
import './loader.scss'
function Spinner() {
  return (
    <div className="preloader">
      <div className="spinner"></div>
    </div>
  );
}

export default Spinner;
